export const FaqList = [
  {
    id: 0,
    title: "What is the Shariah contract applicable?",
    content: "The applicable Shariah contract is Commodity Murabahah.",
  },
  {
    id: 1,
    title: "What is the minimum and maximum tenure?",
    content:
      "The financing tenure is ranging from minimum 1 year up to 8 years, subject to terms and conditions.",
  },
  {
    id: 2,
    title: "What is the minimum and maximum financing amount?",
    content: "Minimum financing amount is RM10,000 and maximum financing amount is RM50,000, subject to terms and conditions.",
  },
  {
    id: 3,
    title: "Is takaful / insurance coverage compulsory?",
    content: "The takaful / insurance coverage is optional.",
  },
  {
    id: 4,
    title: "<span>How to apply Personal <span className='no-wrap'>Financing-<i>i</i> ?</span></span>",
    content:
      "<p>You may walk-in to the nearest branch, or contact our call centre at +603 2332 6000, or share your contact details in this link <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>Product Enquiry</a> , our bank representative will contact to assist you.</p>",
  },
  {
    id: 5,
    title: "How do I pay for the monthly installment?",
    content:
      "You are required to deposit the monthly instalment in your financing account on or before its due date until the full settlement of the financing.",
  },
  {
    id: 6,
    title: "What if I fully settle the financing before its maturity?",
    content:
      "<p>You may opt to fully settle the financing prior to the maturity date. Rebate will be granted by the Bank in accordance with Bank Negara Malaysia Guidelines and our internal rebate (Ibra’) guideline.</p>",
  },
  {
    id: 7,
    title: "How do I contact alrajhi bank Malaysia?",
    content:
      "<p>For more information, kindly contact one of our 24-Hour Customer Care Consultants using your preferred method below:</p><p>+603 2332 6000</p><p>customersupport@alrajhibank.com.my</p>",
  },
];
export const FaqListHighIncome = [
  {
    id: 0,
    title: "What is the Shariah contract applicable?",
    content: "The applicable Shariah contract is Commodity Murabahah.",
  },
  {
    id: 1,
    title: "What is the minimum and maximum tenure?",
    content:
      "The financing tenure is ranging from minimum 1 year up to 8 years, subject to terms and conditions.",
  },
  {
    id: 2,
    title: "What is the minimum and maximum financing amount?",
    content: "Minimum financing amount is RM1,000 and maximum financing amount is RM250,000, subject to terms and conditions.",
  },
  {
    id: 3,
    title: "Is takaful / insurance coverage compulsory?",
    content: "The takaful / insurance coverage is optional.",
  },
  {
    id: 4,
    title: "<span>How to apply Personal <span className='no-wrap'>Financing-<i>i</i> ?</span></span>",
    content:
      "<p>You may walk-in to the nearest branch, or contact our call centre at +603 2332 6000, or share your contact details in this link <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>Product Enquiry</a> , our bank representative will contact to assist you.</p>",
  },
  {
    id: 5,
    title: "How do I pay for the monthly installment?",
    content:
      "You are required to deposit the monthly instalment in your financing account on or before its due date until the full settlement of the financing.",
  },
  {
    id: 6,
    title: "What if I fully settle the financing before its maturity?",
    content:
      "<p>You may opt to fully settle the financing prior to the maturity date. Rebate will be granted by the Bank in accordance with Bank Negara Malaysia Guidelines and our internal rebate (Ibra’) guideline.</p>",
  },
  {
    id: 7,
    title: "How do I contact alrajhi bank Malaysia?",
    content:
      "<p>For more information, kindly contact one of our 24-Hour Customer Care Consultants using your preferred method below:</p><p>+603 2332 6000</p><p>customersupport@alrajhibank.com.my</p>",
  },
];

export const FaqListUmrah = [
  {
    id: 0,
    title: "Apakah kontrak Syariah yang digunakan?",
    content: "Kontrak Syariah yang berkenaan ialah Komoditi Murabahah.",
  },
  {
    id: 1,
    title: "Apakah tempoh pembiayaan minimum dan maksimum?",
    content:
      "Tempoh pembiayaan minimum ialah 1 tahun, dan tempoh pembiayaan maksimum ialah 8 tahun, tertakluk kepada terma dan syarat.",
  },
  {
    id: 2,
    title: "Apakah jumlah pembiayaan minimum dan maksimum?",
    content: "Jumlah pembiayaan minimum ialah RM10,000 dan jumlah pembiayaan maksimum ialah RM50,000, tertakluk kepada terma dan syarat.",
  },
  {
    id: 3,
    title: "Adakah perlindungan takaful / insurans wajib?",
    content: "Perlindungan takaful / insurans tidak diwajibkan.",
  },
  {
    id: 4,
    title: "<span>Bagaimana memohon Pembiayaan <span className='no-wrap'>Peribadi-<i>i</i> ?</span></span>",
    content:
      "<p>Anda boleh datang terus ke cawangan terdekat, atau hubungi talian perkhidmatan pelanggan kami di +603 2332 6000 atau tinggalkan butiran hubungan anda dalam pautan <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>ini</a>, wakil bank kami akan menghubungi untuk membantu anda.</p>",
  },
  {
    id: 5,
    title: "Bagaimana bayar ansuran bulanan?",
    content:
      "Anda dikehendaki mendepositkan ansuran bulanan dalam akaun pembiayaan pada atau sebelum tarikh ansuran matang sehingga penyelesaian penuh pembiayaan.",
  },
  {
    id: 6,
    title: "Bagaimana jika saya menjelaskan sepenuhnya pembiayaan sebelum akhir tempoh pembiayaan?",
    content:
      "Anda boleh membuat penjelasan awal pada bila-bila masa dalam tempoh pembiayaan. Rebat atau Ibra’ akan diberikan sejajar dengan garis panduan Bank Negara Malaysia dan garis panduan Bank.",
  },
  {
    id: 7,
    title: "Bagaimana saya boleh menghubungi alrajhi bank Malaysia?",
    content:
      "Untuk maklumat lanjut, sila hubungi Perunding Khidmat Pelanggan 24 Jam kami di +603 2332 6000, atau emel ke customersupport@alrajhibank.com.my.",
  },
];
export const FaqListUmrahHighIncome = [
  {
    id: 0,
    title: "Apakah kontrak Syariah yang digunakan?",
    content: "Kontrak Syariah yang berkenaan ialah Komoditi Murabahah.",
  },
  {
    id: 1,
    title: "Apakah tempoh pembiayaan minimum dan maksimum?",
    content:
      "Tempoh pembiayaan minimum ialah 2 tahun, dan tempoh pembiayaan maksimum ialah 8 tahun, tertakluk kepada terma dan syarat.",
  },
  {
    id: 2,
    title: "Apakah jumlah pembiayaan minimum dan maksimum?",
    content: "Jumlah pembiayaan minimum ialah RM1,000 dan jumlah pembiayaan maksimum ialah RM250,000, tertakluk kepada terma dan syarat.",
  },
  {
    id: 3,
    title: "Adakah perlindungan takaful / insurans wajib?",
    content: "Perlindungan takaful / insurans tidak diwajibkan.",
  },
  {
    id: 4,
    title: "<span>Bagaimana memohon Pembiayaan <span className='no-wrap'>Peribadi-<i>i</i> ?</span></span>",
    content:
      "<p>Anda boleh datang terus ke cawangan terdekat, atau hubungi talian perkhidmatan pelanggan kami di +603 2332 6000 atau tinggalkan butiran hubungan anda dalam pautan <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>ini</a>, wakil bank kami akan menghubungi untuk membantu anda.</p>",
  },
  {
    id: 5,
    title: "Bagaimana bayar ansuran bulanan?",
    content:
      "Anda dikehendaki mendepositkan ansuran bulanan dalam akaun pembiayaan pada atau sebelum tarikh ansuran matang sehingga penyelesaian penuh pembiayaan.",
  },
  {
    id: 6,
    title: "Bagaimana jika saya menjelaskan sepenuhnya pembiayaan sebelum akhir tempoh pembiayaan?",
    content:
      "Anda boleh membuat penjelasan awal pada bila-bila masa dalam tempoh pembiayaan. Rebat atau Ibra’ akan diberikan sejajar dengan garis panduan Bank Negara Malaysia dan garis panduan Bank.",
  },
  {
    id: 7,
    title: "Bagaimana saya boleh menghubungi alrajhi bank Malaysia?",
    content:
      "Untuk maklumat lanjut, sila hubungi Perunding Khidmat Pelanggan 24 Jam kami di +603 2332 6000, atau emel ke customersupport@alrajhibank.com.my.",
  },
];

export const FaqListTdi = [
  {
    id: 0,
    title: "What is the Shariah contract applicable?",
    content: "The applicable Shariah contract is Commodity Murabahah.",
  },
  {
    id: 1,
    title: "What is the minimum and maximum tenure?",
    content:
      "The financing tenure is ranging from minimum 1 year up to 7 years, subject to terms and conditions.",
  },
  {
    id: 2,
    title: "What is the minimum and maximum financing amount?",
    content: "Minimum financing amount is RM5,000 and maximum financing amount is RM500,000, subject to terms and conditions.",
  },
  {
    id: 3,
    title: "Is takaful / insurance coverage compulsory?",
    content: "The takaful / insurance coverage is optional.",
  },
  {
    id: 4,
    title: "<span>How to apply Personal <span className='no-wrap'>Financing-<i>i</i> ?</span></span>",
    content:
      "<p>You may walk-in to the nearest branch, or contact our call centre at +603 2332 6000, or share your contact details in this link <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>Product Enquiry</a> , our bank representative will contact to assist you.</p>",
  },
  {
    id: 5,
    title: "How do I pay for the monthly installment?",
    content:
      "You are required to deposit the monthly instalment in your financing account on or before its due date until the full settlement of the financing.",
  },
  {
    id: 6,
    title: "What if I fully settle the financing before its maturity?",
    content:
      "<p>You may opt to fully settle the financing prior to the maturity date. If the facility is settled within first 5 years from the date of the first disbursement, the Bank shall have the right to claim actual entry costs (if any).</p><p>Rebate will be granted by the Bank in accordance with Bank Negara Malaysia Guidelines and our internal rebate (Ibra’) guideline.</p><p>The customer may at any time after the completion of each Sale transaction pay the entire amount of the Bank Sale price or any part thereof then owing to the Bank as the Bank may in absolute discretion accept.</p>",
  },
  {
    id: 7,
    title: "How do I contact alrajhi bank Malaysia?",
    content:
      "<p>For more information, kindly contact one of our 24-Hour Customer Care Consultants using your preferred method below:</p><p>+603 2332 6000</p><p>customersupport@alrajhibank.com.my</p>",
  },
];
export const FaqListTdiHighIncome = [
  {
    id: 0,
    title: "What is the Shariah contract applicable?",
    content: "The applicable Shariah contract is Commodity Murabahah.",
  },
  {
    id: 1,
    title: "What is the minimum and maximum tenure?",
    content:
      "The financing tenure is ranging from minimum 1 year up to 7 years, subject to terms and conditions.",
  },
  {
    id: 2,
    title: "What is the minimum and maximum financing amount?",
    content: "Minimum financing amount is RM5,000 and maximum financing amount is RM500,000, subject to terms and conditions.",
  },
  {
    id: 3,
    title: "Is takaful / insurance coverage compulsory?",
    content: "The takaful / insurance coverage is optional.",
  },
  {
    id: 4,
    title: "<span>How to apply Personal <span className='no-wrap'>Financing-<i>i</i> ?</span></span>",
    content:
      "<p>You may walk-in to the nearest branch, or contact our call centre at +603 2332 6000, or share your contact details in this link <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>Product Enquiry</a> , our bank representative will contact to assist you.</p>",
  },
  {
    id: 5,
    title: "How do I pay for the monthly installment?",
    content:
      "You are required to deposit the monthly instalment in your financing account on or before its due date until the full settlement of the financing.",
  },
  {
    id: 6,
    title: "What if I fully settle the financing before its maturity?",
    content:
      "<p>You may opt to fully settle the financing prior to the maturity date. If the facility is settled within first 5 years from the date of the first disbursement, the Bank shall have the right to claim actual entry costs (if any).</p><p>Rebate will be granted by the Bank in accordance with Bank Negara Malaysia Guidelines and our internal rebate (Ibra’) guideline.</p><p>The customer may at any time after the completion of each Sale transaction pay the entire amount of the Bank Sale price or any part thereof then owing to the Bank as the Bank may in absolute discretion accept.</p>",
  },
  {
    id: 7,
    title: "How do I contact alrajhi bank Malaysia?",
    content:
      "<p>For more information, kindly contact one of our 24-Hour Customer Care Consultants using your preferred method below:</p><p>+603 2332 6000</p><p>customersupport@alrajhibank.com.my</p>",
  },
];


export const FaqListEbs = [
  {
    id: 0,
    title: "What is the Shariah contract applicable?",
    content: "The applicable Shariah contract is Commodity Murabahah.",
  },
  {
    id: 1,
    title: "What is the minimum and maximum tenure?",
    content:
      "The financing tenure is ranging from minimum 2 years up to 8 years, subject to terms and conditions.",
  },
  {
    id: 2,
    title: "What is the minimum and maximum financing amount?",
    content: "Minimum financing amount is RM5,000 and maximum financing amount is RM80,000, subject to terms and conditions.",
  },
  {
    id: 3,
    title: "Is takaful / insurance coverage compulsory?",
    content: "The takaful / insurance coverage is optional.",
  },
  {
    id: 4,
    title: "<span>How to apply Personal <span className='no-wrap'>Financing-<i>i</i> ?</span></span>",
    content:
      "<p>You may walk-in to the nearest branch, or contact our call centre at +603 2332 6000, or share your contact details in this link <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>Product Enquiry</a> , our bank representative will contact to assist you.</p>",
  },
  {
    id: 5,
    title: "How do I pay for the monthly installment?",
    content:
      "You are required to deposit the monthly instalment in your financing account on or before its due date until the full settlement of the financing.",
  },
  {
    id: 6,
    title: "What if I fully settle the financing before its maturity?",
    content:
      "<p>You may opt to fully settle the financing prior to the maturity date. If the facility is settled within first 5 years from the date of the first disbursement, the Bank shall have the right to claim actual entry costs (if any).</p><p>Rebate will be granted by the Bank in accordance with Bank Negara Malaysia Guidelines and our internal rebate (Ibra’) guideline.</p><p>The customer may at any time after the completion of each Sale transaction pay the entire amount of the Bank Sale price or any part thereof then owing to the Bank as the Bank may in absolute discretion accept.</p>",
  },
  {
    id: 7,
    title: "How do I contact alrajhi bank Malaysia?",
    content:
      "<p>For more information, kindly contact one of our 24-Hour Customer Care Consultants using your preferred method below:</p><p>+603 2332 6000</p><p>customersupport@alrajhibank.com.my</p>",
  },
];
export const FaqListEbsHighIncome = [
  {
    id: 0,
    title: "What is the Shariah contract applicable?",
    content: "The applicable Shariah contract is Commodity Murabahah.",
  },
  {
    id: 1,
    title: "What is the minimum and maximum tenure?",
    content:
      "The financing tenure is ranging from minimum 2 years up to 10 years, subject to terms and conditions.",
  },
  {
    id: 2,
    title: "What is the minimum and maximum financing amount?",
    content: "Minimum financing amount is RM5,000 and maximum financing amount is RM250,000, subject to terms and conditions.",
  },
  {
    id: 3,
    title: "Is takaful / insurance coverage compulsory?",
    content: "The takaful / insurance coverage is optional.",
  },
  {
    id: 4,
    title: "<span>How to apply Personal <span className='no-wrap'>Financing-<i>i</i> ?</span></span>",
    content:
      "<p>You may walk-in to the nearest branch, or contact our call centre at +603 2332 6000, or share your contact details in this link <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>Product Enquiry</a> , our bank representative will contact to assist you.</p>",
  },
  {
    id: 5,
    title: "How do I pay for the monthly installment?",
    content:
      "You are required to deposit the monthly instalment in your financing account on or before its due date until the full settlement of the financing.",
  },
  {
    id: 6,
    title: "What if I fully settle the financing before its maturity?",
    content:
      "<p>You may opt to fully settle the financing prior to the maturity date. If the facility is settled within first 5 years from the date of the first disbursement, the Bank shall have the right to claim actual entry costs (if any).</p><p>Rebate will be granted by the Bank in accordance with Bank Negara Malaysia Guidelines and our internal rebate (Ibra’) guideline.</p><p>The customer may at any time after the completion of each Sale transaction pay the entire amount of the Bank Sale price or any part thereof then owing to the Bank as the Bank may in absolute discretion accept.</p>",
  },
  {
    id: 7,
    title: "How do I contact alrajhi bank Malaysia?",
    content:
      "<p>For more information, kindly contact one of our 24-Hour Customer Care Consultants using your preferred method below:</p><p>+603 2332 6000</p><p>customersupport@alrajhibank.com.my</p>",
  },
];

export const FaqListCCSPSD = [
  {
    id: 0,
    title: "What is the Shariah contract applicable?",
    content: "The applicable Shariah contract is Commodity Murabahah.",
  },
  {
    id: 1,
    title: "What is the minimum and maximum tenure?",
    content:
      "The financing tenure is ranging from minimum 2 years up to 8 years, subject to terms and conditions.",
  },
  {
    id: 2,
    title: "What is the minimum and maximum financing amount?",
    content: "Minimum financing amount is RM5,000 and maximum financing amount is RM80,000, subject to terms and conditions.",
  },
  {
    id: 3,
    title: "Is takaful / insurance coverage compulsory?",
    content: "The takaful / insurance coverage is optional.",
  },
  {
    id: 4,
    title: "<span>How to apply Personal <span className='no-wrap'>Financing-<i>i</i> ?</span></span>",
    content:
      "<p>You may walk-in to the nearest branch, or contact our call centre at +603 2332 6000, or share your contact details in this link <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>Product Enquiry</a> , our bank representative will contact to assist you.</p>",
  },
  {
    id: 5,
    title: "How do I pay for the monthly installment?",
    content:
      "You are required to deposit the monthly instalment in your financing account on or before its due date until the full settlement of the financing.",
  },
  {
    id: 6,
    title: "What if I fully settle the financing before its maturity?",
    content:
      "<p>You may opt to fully settle the financing prior to the maturity date. If the facility is settled within first 5 years from the date of the first disbursement, the Bank shall have the right to claim actual entry costs (if any).</p><p>Rebate will be granted by the Bank in accordance with Bank Negara Malaysia Guidelines and our internal rebate (Ibra’) guideline.</p><p>The customer may at any time after the completion of each Sale transaction pay the entire amount of the Bank Sale price or any part thereof then owing to the Bank as the Bank may in absolute discretion accept.</p>",
  },
  {
    id: 7,
    title: "How do I contact alrajhi bank Malaysia?",
    content:
      "<p>For more information, kindly contact one of our 24-Hour Customer Care Consultants using your preferred method below:</p><p>+603 2332 6000</p><p>customersupport@alrajhibank.com.my</p>",
  },
];
export const FaqListCCSPSDHighIncome = [
  {
    id: 0,
    title: "What is the Shariah contract applicable?",
    content: "The applicable Shariah contract is Commodity Murabahah.",
  },
  {
    id: 1,
    title: "What is the minimum and maximum tenure?",
    content:
      "The financing tenure is ranging from minimum 2 years up to 10 years, subject to terms and conditions.",
  },
  {
    id: 2,
    title: "What is the minimum and maximum financing amount?",
    content: "Minimum financing amount is RM5,000 and maximum financing amount is RM250,000, subject to terms and conditions.",
  },
  {
    id: 3,
    title: "Is takaful / insurance coverage compulsory?",
    content: "The takaful / insurance coverage is optional.",
  },
  {
    id: 4,
    title: "<span>How to apply Personal <span className='no-wrap'>Financing-<i>i</i> ?</span></span>",
    content:
      "<p>You may walk-in to the nearest branch, or contact our call centre at +603 2332 6000, or share your contact details in this link <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>Product Enquiry</a> , our bank representative will contact to assist you.</p>",
  },
  {
    id: 5,
    title: "How do I pay for the monthly installment?",
    content:
      "You are required to deposit the monthly instalment in your financing account on or before its due date until the full settlement of the financing.",
  },
  {
    id: 6,
    title: "What if I fully settle the financing before its maturity?",
    content:
      "<p>You may opt to fully settle the financing prior to the maturity date. If the facility is settled within first 5 years from the date of the first disbursement, the Bank shall have the right to claim actual entry costs (if any).</p><p>Rebate will be granted by the Bank in accordance with Bank Negara Malaysia Guidelines and our internal rebate (Ibra’) guideline.</p><p>The customer may at any time after the completion of each Sale transaction pay the entire amount of the Bank Sale price or any part thereof then owing to the Bank as the Bank may in absolute discretion accept.</p>",
  },
  {
    id: 7,
    title: "How do I contact alrajhi bank Malaysia?",
    content:
      "<p>For more information, kindly contact one of our 24-Hour Customer Care Consultants using your preferred method below:</p><p>+603 2332 6000</p><p>customersupport@alrajhibank.com.my</p>",
  },
];

export const FaqListBusiness = [
  {
    id: 0,
    title: "What is the Shariah contract applicable?",
    content: "The applicable Shariah contract is Commodity Murabahah.",
  },
  {
    id: 1,
    title: "What is the minimum and maximum tenure?",
    content:
      "The financing tenure is ranging from minimum 5 years up to 25 years, subject to terms and conditions.",
  },
  {
    id: 2,
    title: "What is the minimum and maximum financing amount?",
    content: "The Minimum financing amount is RM50,000.",
  },
  {
    id: 3,
    title: "Is Mortgage Reducing Term Takaful (MRTT) coverage compulsory?",
    content: "The Mortgage Reducing Term Takaful (MRTT) coverage is optional.",
  },
  {
    id: 4,
    title: "<span>How to apply Home <span className='no-wrap'>Financing-<i>i</i> ?</span></span>",
    content:
      "<p>You may walk-in to the nearest branch, or contact our call centre at +603 2332 6000, or share your contact details in this link <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>Product Enquiry</a> , our bank representative will contact to assist you.</p>",
  },
  {
    id: 5,
    title: "How do I pay for the monthly installment?",
    content:
      "You are required to deposit the monthly instalment in your financing account on or before its due date until the full settlement of the financing.",
  },
  {
    id: 6,
    title: "What if I fully settle the financing before its maturity?",
    content:
      "<p>You may opt to fully settle the financing prior to the maturity date. If the facility is settled within first 5 years from the date of the first disbursement, the Bank shall have the right to claim actual entry costs (if any).</p><p>Rebate will be granted by the Bank in accordance with Bank Negara Malaysia Guidelines and our internal rebate (Ibra’) guideline.</p><p>The customer may at any time after the completion of each Sale transaction pay the entire amount of the Bank Sale price or any part thereof then owing to the Bank as the Bank may in absolute discretion accept.</p>",
  },
  {
    id: 7,
    title: "How do I contact alrajhi bank Malaysia?",
    content:
      "<p>For more information, kindly contact one of our 24-Hour Customer Care Consultants using your preferred method below:</p><p>+603 2332 6000</p><p>customersupport@alrajhibank.com.my</p>",
  },
];
export const FaqListPFHome = [
  {
    id: 0,
    title: "What is the Shariah contract applicable?",
    content: "The applicable Shariah contract is Commodity Murabahah.",
  },
  {
    id: 1,
    title: "What is the minimum and maximum tenure?",
    content:
      "The financing tenure is ranging from minimum 5 years up to 35 years, subject to terms and conditions.",
  },
  {
    id: 2,
    title: "What is the minimum and maximum financing amount?",
    content: "The Minimum financing amount is RM50,000.",
  },
  {
    id: 3,
    title: "Is Mortgage Reducing Term Takaful (MRTT) coverage compulsory?",
    content: "The Mortgage Reducing Term Takaful (MRTT) coverage is optional.",
  },
  {
    id: 4,
    title: "<span>How to apply Home <span className='no-wrap'>Financing-<i>i</i> ?</span></span>",
    content:
      "<p>You may walk-in to the nearest branch, or contact our call centre at +603 2332 6000, or share your contact details in this link <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>Product Enquiry</a> , our bank representative will contact to assist you.</p>",
  },
  {
    id: 5,
    title: "How do I pay for the monthly installment?",
    content:
      "You are required to deposit the monthly instalment in your financing account on or before its due date until the full settlement of the financing.",
  },
  {
    id: 6,
    title: "What if I fully settle the financing before its maturity?",
    content:
      "<p>You may opt to fully settle the financing prior to the maturity date. If the facility is settled within first 5 years from the date of the first disbursement, the Bank shall have the right to claim actual entry costs (if any).</p><p>Rebate will be granted by the Bank in accordance with Bank Negara Malaysia Guidelines and our internal rebate (Ibra’) guideline.</p><p>The customer may at any time after the completion of each Sale transaction pay the entire amount of the Bank Sale price or any part thereof then owing to the Bank as the Bank may in absolute discretion accept.</p>",
  },
  {
    id: 7,
    title: "How do I contact alrajhi bank Malaysia?",
    content:
      "<p>For more information, kindly contact one of our 24-Hour Customer Care Consultants using your preferred method below:</p><p>+603 2332 6000</p><p>customersupport@alrajhibank.com.my</p>",
  },
];
export const FaqListPFHomeOne = [
  {
    id: 0,
    title: "What is the Shariah contract applicable?",
    content: "The applicable Shariah contract is Commodity Murabahah.",
  },
  {
    id: 1,
    title: "What is the minimum and maximum tenure?",
    content:
      "The financing tenure is ranging from minimum 5 years up to 35 years, subject to terms and conditions.",
  },
  {
    id: 2,
    title: "What is the minimum and maximum financing amount?",
    content: "The Minimum financing amount is RM50,000.",
  },
  {
    id: 3,
    title: "Is Mortgage Reducing Term Takaful (MRTT) coverage compulsory?",
    content: "The Mortgage Reducing Term Takaful (MRTT) coverage is optional.",
  },
  {
    id: 4,
    title: "<span>How to apply Home <span className='no-wrap'>Financing-<i>i</i> ?</span></span>",
    content:
      "<p>You may walk-in to the nearest branch, or contact our call centre at +603 2332 6000, or share your contact details in this link <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>Product Enquiry</a> , our bank representative will contact to assist you.</p>",
  },
  {
    id: 5,
    title: "How do I pay for the monthly installment?",
    content:
      "You are required to deposit the monthly instalment in your financing account on or before its due date until the full settlement of the financing.",
  },
  {
    id: 6,
    title: "What if I fully settle the financing before its maturity?",
    content:
      "<p>You may opt to fully settle the financing prior to the maturity date. If the facility is settled within first 5 years from the date of the first disbursement, the Bank shall have the right to claim actual entry costs (if any).</p><p>Rebate will be granted by the Bank in accordance with Bank Negara Malaysia Guidelines and our internal rebate (Ibra’) guideline.</p><p>The customer may at any time after the completion of each Sale transaction pay the entire amount of the Bank Sale price or any part thereof then owing to the Bank as the Bank may in absolute discretion accept.</p>",
  },
  {
    id: 7,
    title: "How do I contact alrajhi bank Malaysia?",
    content:
      "<p>For more information, kindly contact one of our 24-Hour Customer Care Consultants using your preferred method below:</p><p>+603 2332 6000</p><p>customersupport@alrajhibank.com.my</p>",
  },
];